import { getFixedT, useTranslation } from '@app/core/i18n';

const nameSpace = 'make-transfer';

export const useMakeTransferTranslation = () => useTranslation(nameSpace);
export const t = getFixedT(null, nameSpace);
